import includes from 'lodash/includes';

export const isDataFederationUnsupportedAssetType = ({ displayType }) => {
  // The `isDataFederationUnsupportedAssetType()` method in the View model in Core implements this same logic.
  return includes(['calendar', 'chart', 'form', 'map'], displayType);
};
